import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { ICurrentWorkspaceStore } from '../../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { Home } from '../../../routes/config/Home';
import { IErrorsService } from '../errors.service';
import { IErrorsStore } from '../errors.store';

export const NotAuthorizedContainer = observer((props: PropsWithChildren): ReactElement => {
  const errorsStore = useInjection(IErrorsStore.$);
  const errorsService = useInjection(IErrorsService.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);

  const { t } = useTranslator();
  const history = useHistory();

  const navigateToProjectsList = (): void => {
    errorsService.clearUnauthorized();
    history.push(Home.Projects.List.All.withParams({ workspaceId: currentWorkspaceStore.currentWorkspace.id }));
  };

  const refresh = (): void => {
    history.go(0);
  };

  const isAuthorized = errorsStore.isAuthorized;

  return isAuthorized ? (
    <>{props.children}</>
  ) : (
    <div className='not-authorized-page'>
      <h1>403</h1>
      <p>
        {t('403_body')} <br /> {t('403_body2')}
      </p>
      <div className='not-authorized-page-buttons'>
        <Button onClick={navigateToProjectsList}>{t('projects_header')}</Button>
        <Button
          onClick={refresh}
          startDecorator={<FontAwesomeIcon icon='sync' />}
        >
          {t('refresh')}
        </Button>
      </div>
    </div>
  );
});
